import React, {Fragment} from 'react'
import List from '../../../../components/Project/Resources/ClientBudgets/List'
import ClientBudgetModal from '../../../../components/Project/Resources/ClientBudgets/ClientBudgetModal'

function ClientBudgets(props) {
  return (
    <Fragment>
      <ClientBudgetModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

ClientBudgets.propTypes = {}
ClientBudgets.defaultProps = {}

export default ClientBudgets
